import React from 'react';
import AvisoPrivacidadMexico from './AvisoPrivacidadMexico';
import CondicionesGeneralesMexico from './CondicionesGeneralesMexico';

export default function TextConditionsMexico({
  emailContacto,
  company,
  webUrl,
  razonSocial,
  domicilio,
  arcoNombre,
  arcoDomicilio,
  arcoEmail,
  arcoTelefono,
  fechaUltimaActualizacion,
}) {
  const hasAvisoData =
    razonSocial || domicilio || webUrl || emailContacto ||
    arcoNombre || arcoDomicilio || arcoEmail || arcoTelefono;

  return (
    <div className='text-sm text-gray-400 text-justify space-y-12'>
      {hasAvisoData && (
        <section id='aviso-privacidad' className='scroll-mt-8'>
          <AvisoPrivacidadMexico
            emailContacto={emailContacto}
            webUrl={webUrl}
            razonSocial={razonSocial}
            domicilio={domicilio}
            arcoNombre={arcoNombre}
            arcoDomicilio={arcoDomicilio}
            arcoEmail={arcoEmail}
            arcoTelefono={arcoTelefono}
            fechaUltimaActualizacion={fechaUltimaActualizacion}
          />
        </section>
      )}

      <section id='condiciones-generales' className='scroll-mt-8'>
        <CondicionesGeneralesMexico
          emailContacto={emailContacto}
          company={company}
          razonSocial={razonSocial}
        />
      </section>
    </div>
  );
}
